import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';

const AudienceContext = createContext(null);

export function AudienceProvider({ children }) {
  const [audience, setAudience] = useState(() => {
    try { return localStorage.getItem('mi_audience') || 'b2b'; } catch { return 'b2b'; }
  });
  useEffect(() => {
    try { localStorage.setItem('mi_audience', audience); } catch {}
  }, [audience]);
  const value = useMemo(() => ({ audience, setAudience, isB2B: audience === 'b2b' }), [audience]);
  return <AudienceContext.Provider value={value}>{children}</AudienceContext.Provider>;
}

export function useAudience() {
  const ctx = useContext(AudienceContext);
  if (!ctx) throw new Error('useAudience must be inside AudienceProvider');
  return ctx;
}
